import { forEach } from 'lodash';
import { Base, OwnedObject, isArray } from 'gear';
import { Figures } from '../figure';

export const Template = Base.extend({ typeName: 'Template',

  init ( doc ) {
    this.doc = doc;
  },

  document() { return this.doc; },

  addClipart$( clipart ) {
    if( ! isArray(clipart) ) {
      clipart = [clipart];
    }

    const doc = this.doc;
    doc.lock();

    clipart = OwnedObject.adopt( clipart, null );

    return doc.bounds$() .then( bounds => {

    return Figures.center$( clipart, bounds ) .then( () => {

    return Figures.setSize$( clipart, { width: bounds.width/2, height: bounds.height/2, fit: 'Mean' }) .then( () => {

    doc.add( clipart );
    return clipart;
    });});});
  },

  replaceClipart$( old, clipart ) {
    const doc = this.doc;

    if( ! isArray(old) ) {
      old = [old];
    }
    if( ! isArray(clipart) ) {
      clipart = [clipart];
    }

    Figures.lock(old);

    clipart = OwnedObject.adopt( clipart, null );

    // Replace colors of the new clipart with the previous colors (using tags)
    const oldColors = {};
    Figures.forEachColor( old, c => {
      const t = c._tag;
      if( t && ! oldColors[t] ) {
        oldColors[t]=c;
      }
    });
    Figures.forEachColor( clipart, c => {
      const t = c._tag;
      if( t && oldColors[t] ) {
        c.replace(oldColors[t]);
      }
    });
    
    if (old.length === 1 && old[0]._owner && old[0]._owner.isGroup) {
      const lGroup = old[0]._owner;
      let lFigures = lGroup.ungroup();
      const i = lFigures.indexOf(old[0]);
      lFigures.splice(i,1);
      const matrix22 = old[0]._matrix22 ;
      Figures.transform(clipart, matrix22);
      
      return Figures.fit$( clipart, old, {fit:'Mean'} ) .then( () => {  
        
        const xType = 'System.Clipart';
        forEach( clipart, c => c.xType = xType );    
        
        lFigures.insert(i,clipart);
        let lNG = Cx.Group.create(lFigures);
        doc.replace( lGroup, lNG );
        return clipart;    
        
      });
    }
    else {
      const matrix22 = old.length === 1 ? old[0]._matrix22 : Figures.composedIsometricMatrix22(old) ;
      Figures.transform(clipart, matrix22);
  
      return Figures.fit$( clipart, old, {fit:'Mean'} ) .then( () => {
  
      const xType = 'System.Clipart';
      forEach( clipart, c => c.xType = xType );
  
      doc.replace( old, clipart );
      return clipart;
  
      });
    }

  }
});



/** WEBPACK FOOTER **
 ** ./src/cdl/document/template.js
 **/